/* eslint-disable import/prefer-default-export */
import Vue from "vue";
import { courseEntityApi } from "../../services/adminApis/CourseEntityApi";
import { customerApi } from "../../services/customerApi";

export const regularCourseJs = new Vue({
  methods: {
    async addCourse(courseData, token) {
      const requestData = {
        name: courseData.name,
        duration: courseData.duration,
        imageUrl: courseData.imageUrl,
        totalVideos: courseData.totalVideos,
        price: courseData.price,
        subject: courseData.subject,
        description: courseData.description,
        categoryId: courseData.category.category_id,
        courseSpeciality: courseData.courseSpeciality.join(","),
        courseProperties: courseData.courseProperties
      };
      const res = await courseEntityApi.addCourse(token, requestData);
      await customerApi.getTeacherCourses();
      return res;
    },
    async editCourse(courseData, token) {
      const requestData = {
        name: courseData.name,
        courseId: courseData.courseId,
        duration: courseData.duration,
        imageUrl: courseData.imageUrl,
        totalVideos: courseData.totalVideos,
        price: courseData.price,
        subject: courseData.subject,
        description: courseData.description,
        categoryId: courseData.categoryId,
        courseSpeciality: courseData.courseSpeciality.join(","),
        courseProperties: courseData.courseProperties
      };
      const response = await courseEntityApi.editCourse(token, requestData);
      await customerApi.getTeacherCourses();
      return response;
    }
  }
});
